/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PurchaseResponse
 */
export interface PurchaseResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseResponse
     */
    itemId: string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseResponse
     */
    tokenBalance: number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseResponse
     */
    totalPurchases: number;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseResponse
     */
    victoryUnlocked: boolean;
}

/**
 * Check if a given object implements the PurchaseResponse interface.
 */
export function instanceOfPurchaseResponse(value: object): value is PurchaseResponse {
    if (!('itemId' in value) || value['itemId'] === undefined) return false;
    if (!('tokenBalance' in value) || value['tokenBalance'] === undefined) return false;
    if (!('totalPurchases' in value) || value['totalPurchases'] === undefined) return false;
    if (!('victoryUnlocked' in value) || value['victoryUnlocked'] === undefined) return false;
    return true;
}

export function PurchaseResponseFromJSON(json: any): PurchaseResponse {
    return PurchaseResponseFromJSONTyped(json, false);
}

export function PurchaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PurchaseResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'itemId': json['itemId'],
        'tokenBalance': json['tokenBalance'],
        'totalPurchases': json['totalPurchases'],
        'victoryUnlocked': json['victoryUnlocked'],
    };
}

export function PurchaseResponseToJSON(json: any): PurchaseResponse {
    return PurchaseResponseToJSONTyped(json, false);
}

export function PurchaseResponseToJSONTyped(value?: PurchaseResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'itemId': value['itemId'],
        'tokenBalance': value['tokenBalance'],
        'totalPurchases': value['totalPurchases'],
        'victoryUnlocked': value['victoryUnlocked'],
    };
}

